<template>
  <div class="quick-ship-filter">
    <button
      type="button"
      class="quick-ship-filter__badge js-quick-ship-filter-badge"
      :class="{ 'is-selected': isActive }"
      @click="handleBadgeClick"
    >
      <span
        class="quick-ship-filter__badge-icon icon icon--shipping-truck"
        aria-hidden="true"
      />
      <span class="quick-ship-filter__badge-text">Quick Ship</span>
      <button
        v-if="isActive"
        type="button"
        class="quick-ship-filter__badge-close"
        aria-label="Clear Quick Ship filter"
        @click.stop="clearQuickShip"
      >
        <span
          class="icon icon--close"
          aria-hidden="true"
        />
      </button>
    </button>
  </div>
</template>

<script>
import { ref, onMounted } from "vue";

export default {
  name: "QuickShipFilter",
  setup() {
    const isActive = ref(false);

    function handleBadgeClick() {
      isActive.value = true;

      window.dispatchEvent(new CustomEvent("pickupStoreDeactivated"));
      window.dispatchEvent(new CustomEvent("quickShipFilterChanged", {
        detail: { active: true }
      }));
    }

    function handleQuickShipDeactivated() {
      if (!isActive.value) return;
      // Hide Quick Ship filter
      isActive.value = false;
      window.dispatchEvent(new CustomEvent("quickShipFilterChanged", {
        detail: { active: false }
      }));
    }

    function clearQuickShip(event) {
      event.stopPropagation();
      handleQuickShipDeactivated();

      // Show Same Day Pickup filter when Quick Ship is cleared
      window.dispatchEvent(new CustomEvent("pickupStoreActivated"));
    }

    onMounted(() => {
      window.dispatchEvent(new CustomEvent("quickShipFilterChanged", {
        detail: { active: false }
      }));

      window.addEventListener("clearAllAvailabilityFilters", () => {
        handleQuickShipDeactivated();
      });
    });

    return {
      isActive,
      handleBadgeClick,
      clearQuickShip
    };
  }
};
</script>

